import React from 'react';
import Icon from './Icon';

const SaveIcon = (props) => (
    <Icon {...props}>
        <path
            d="M19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H16L21 8V19C21 20.1 20.1 21 19 21ZM7 3V8H15V3M7 21V13H17V21"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default SaveIcon;
